<template>
  <div id="container" class="yiyoPrivacyStatement" style="height: 100%">
    <P class="yiyoPrivacyStatementTitle">YIYO翻译隐私声明</p>
    <p class="yiyoPrivacyStatementContent">感谢您选择和使用YIYO翻译软件服务</p>
    <p class="yiyoPrivacyStatementContent">YIYO翻译是一款由杭州译友网络科技有公司（注册地为浙江省杭州市，以下亦简称“我们”或“YIYO”或“译友”）提供服务的社交类和生产力工具类产品。我们尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，我们将按照法律法规要求，采取相应的安全保护措施。我们希望通过本《YIYO翻译隐私声明》向您说明，在您使用我们提供的产品、服务时，我们如何收集、使用、和保护信息的方法。</p>
    <p class="yiyoPrivacyStatementSubTitle">一、适用范围</p>
      <p class="yiyoPrivacyStatementSubContent">1、在您注册本软件账号时，您根据本软件要求提供的个人注册信息；</p>
      <p class="yiyoPrivacyStatementSubContent">2、在您使用本软件网络服务，或访问本软件后端平台时，本软件自动接收并记录的计算机信息，包括但不限于您的IP地址、时间等；</p>
      <p class="yiyoPrivacyStatementSubContent">3、在您使用本软件翻译功能时，您输入的文本信息、语言类型等。</p>
    <p class="yiyoPrivacyStatementSubTitle">二、信息使用</p>
      <p class="yiyoPrivacyStatementSubContent">1、本软件不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息。其将被禁止访问包括其以前能够访问的所有这些资料；</p>
      <p class="yiyoPrivacyStatementSubContent">2、本软件亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。 任何本软件平台用户如从事上述活动，一经发现，本软件有权立即终止与该用户的服 务协议；</p>
      <p class="yiyoPrivacyStatementSubContent">3、根据中国法律相关规定，可根据行政或司法机构的要求出具相关信息。</p>
    <p class="yiyoPrivacyStatementSubTitle">三、信息安全</p>
      <p class="yiyoPrivacyStatementSubContent">1、我们对用户数据敏感信息均有安全保护措施；</p>
      <p class="yiyoPrivacyStatementSubContent">2、请妥善保管您的用户名及密码信息。本软件将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但也请您不要想任何人主动提供个人的信息，尤其是涉及本软件账号的安全信息。</p>

  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'PrivacyStatement',
  data () {
    return {
     
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.yiyoPrivacyStatement {
      font-family: "Microsoft Yahei",sans-serif;
      padding: 50px 80px 150px 80px;
      font-size: 12px;
      line-height: 30px;
      padding-bottom: 50px;
      background:#fff;
      text-align:left;
    }
    .yiyoPrivacyStatement .yiyoPrivacyStatementTitle{
      text-align: center;
      font-size: 16px;
      font-weight: bold; 
      margin-bottom: 20px;
    }
    .yiyoPrivacyStatement .yiyoPrivacyStatementSubTitle{
      margin: 10px 0px;
      font-weight: bold;
      /*text-indent: 2em;*/
    }
    .yiyoPrivacyStatement .yiyoPrivacyStatementContent{
      text-indent: 2em;
      /*margin-right: 40px;*/
    }
    .yiyoPrivacyStatement .yiyoPrivacyStatementSubContent{
      text-indent: 2em;
      /*padding-left: 2em;*/
    }
</style>




// WEBPACK FOOTER //
// src/components/PrivacyStatement.vue